import React, { Component } from "react";
import BTlogoHeader from "../../assets/MineThunderLogoWithoutText.png";
import ProfileLogin from "../../assets/Login/login-image.png";

import "./header.css";

class YourComponent extends Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
  }

  focusSearchInput = () => {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  };

  render() {
    const { isSearchBarVisible, handleInputChange, handleKeyDown } = this.props;

    return (
      <>
        {isSearchBarVisible && (
          <div
            className="search-bar"
            onClick={(event) => event.stopPropagation()}
          >
            <input
              type="text"
              className="search-input"
              placeholder="Search"
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              ref={this.searchInputRef}
            />
          </div>
        )}
      </>
    );
  }
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.dropdownRef = React.createRef();
    this.flagDropdownRef = React.createRef();
    this.searchRef = React.createRef();
    this.yourComponentRef = React.createRef();
    this.loginDropdownRef = React.createRef();
  }

  state = {
    isDropdownVisible: false,
    isSearchBarVisible: false,
    isFlagDropdownVisible: false,
    isLoginDropdownVisible: false,
    searchInput: "",
  };
  handleMenuIconClick = () => {
    this.setState((prevState) => ({
      isDropdownVisible: !prevState.isDropdownVisible,
      isFlagDropdownVisible: false,
      isSearchBarVisible: false,
      isLoginDropdownVisible: false,
    }));
  };

  handleSearchIconClick = (event) => {
    event.stopPropagation();

    this.setState(
      (prevState) => ({
        isSearchBarVisible: !prevState.isSearchBarVisible,
        isDropdownVisible: false,
        isFlagDropdownVisible: false,
      }),
      () => {
        if (this.state.isSearchBarVisible && this.yourComponentRef.current) {
          this.yourComponentRef.current.focusSearchInput();
        }
      }
    );
  };

  handleInputChange = (event) => {
    const inputValue = event.target.value.toLowerCase();
    this.setState({ searchInput: inputValue });
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (this.state.searchInput === "packages") {
        window.location.href = "packages";
      } else if (this.state.searchInput === "brands") {
        window.location.href = "https://snaithe.com/about";
      } else if (this.state.searchInput === "history") {
        window.location.href = "https://snaithe.com/history";
      } else if (this.state.searchInput === "brands") {
        window.location.href = "https://snaithe.com/brands";
      } else if (this.state.searchInput === "home") {
        window.location.href = "home";
      } else if (this.state.searchInput === "products") {
        window.location.href = "packages";
      } else if (this.state.searchInput === "services") {
        window.location.href = "services";
      } else if (this.state.searchInput === "service") {
        window.location.href = "services";
      } else if (this.state.searchInput === "product") {
        window.location.href = "packages";
      } else {
        window.location.href = "404-page";
      }
    }
  };

  handleFlagDropdownClick = () => {
    this.setState((prevState) => ({
      isFlagDropdownVisible: !prevState.isFlagDropdownVisible,
      isDropdownVisible: false,
      isSearchBarVisible: false,
      isLoginDropdownVisible: false,
    }));
  };

  handleLoginIconClick = () => {
    this.setState((prevState) => ({
      isLoginDropdownVisible: !prevState.isLoginDropdownVisible,
      isDropdownVisible: false,
      isFlagDropdownVisible: false,
      isSearchBarVisible: false,
    }));
  };

  handleDocumentClick = (event) => {
    const { dropdownRef, flagDropdownRef, searchRef, loginDropdownRef } = this;

    if (
      (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
      (flagDropdownRef.current &&
        flagDropdownRef.current.contains(event.target)) ||
      (searchRef.current && searchRef.current.contains(event.target)) ||
      (loginDropdownRef.current &&
        loginDropdownRef.current.contains(event.target))
    ) {
      return;
    }

    this.setState({
      isFlagDropdownVisible: false,
      isSearchBarVisible: false,
      isLoginDropdownVisible: false,
    });
  };

  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  render() {
    const {
      isDropdownVisible,
      isSearchBarVisible,
      isFlagDropdownVisible,
      isLoginDropdownVisible,
    } = this.state;

    return (
      <div>
        <header className="header">
          <a href="/" className="logo-bidtype">
            <img src={BTlogoHeader} alt="Logo" className="logo-bidtype1" />
          </a>
          {isDropdownVisible && (
            <div className="three-name-header">
              <a href="/" className="Home-1"> 
                <div className="Buy-2">Home</div>
              </a>

              <a href="/products" className="Brands-1">
                <div className="Bid-2">Products</div>
              </a>

              <a href="/services" className="Services-1">
                <div className="Sell-2">Services</div>
              </a>

              <a href="/news" className="Packages-1">
                <div className="Sell-2">News</div>
              </a>

              <a href="/about-terms" className="Packages-1">
                <div className="Sell-2">About</div>
              </a>

              <a href="/contact" className="Packages-1">
                <div className="Sell-2">Contact</div>
              </a>
            </div>
          )}
          <div className="icons">
          
            <div
              className="icon-search-header"
              onClick={this.handleSearchIconClick}
              ref={this.searchRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M6.28849 3.80274e-08C7.48381 -0.000131381 8.65442 0.34037 9.66318 0.981616C10.6719 1.62286 11.4771 2.53829 11.9843 3.62068C12.4914 4.70306 12.6797 5.90756 12.5269 7.09308C12.3742 8.27859 11.8867 9.39603 11.1217 10.3145L15.4595 14.6522C15.5347 14.7221 15.5897 14.811 15.6187 14.9095C15.6477 15.0081 15.6496 15.1126 15.6241 15.2121C15.5987 15.3116 15.5469 15.4024 15.4742 15.4749C15.4014 15.5474 15.3105 15.599 15.2109 15.6242C15.1116 15.6497 15.0071 15.6479 14.9087 15.6191C14.8102 15.5902 14.7213 15.5354 14.6514 15.4603L10.3137 11.1226C9.53746 11.7689 8.61704 12.2187 7.63023 12.434C6.64342 12.6494 5.61927 12.6239 4.6444 12.3597C3.66952 12.0956 2.77261 11.6005 2.02953 10.9164C1.28645 10.2323 0.71906 9.37929 0.375353 8.42954C0.0316463 7.47979 -0.078265 6.46123 0.0549165 5.46002C0.188098 4.45881 0.560455 3.5044 1.14049 2.67752C1.72052 1.85065 2.49117 1.17564 3.38725 0.70958C4.28332 0.243523 5.27846 0.000133388 6.28849 3.80274e-08ZM1.14268 6.28932C1.14268 6.96508 1.27578 7.63422 1.53438 8.25854C1.79299 8.88286 2.17202 9.45012 2.64986 9.92796C3.12769 10.4058 3.69496 10.7848 4.31928 11.0434C4.94359 11.302 5.61274 11.4351 6.28849 11.4351C6.96425 11.4351 7.63339 11.302 8.25771 11.0434C8.88203 10.7848 9.4493 10.4058 9.92713 9.92796C10.405 9.45012 10.784 8.88286 11.0426 8.25854C11.3012 7.63422 11.4343 6.96508 11.4343 6.28932C11.4343 4.92457 10.8922 3.61571 9.92713 2.65069C8.9621 1.68566 7.65325 1.14351 6.28849 1.14351C4.92374 1.14351 3.61488 1.68566 2.64986 2.65069C1.68483 3.61571 1.14268 4.92457 1.14268 6.28932Z"
                  fill="#000"
                />
              </svg>
            </div>
            <div
              className="icon-menu-header"
              onClick={this.handleMenuIconClick}
              ref={this.dropdownRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3 16.7984C3 16.5988 3.07932 16.4073 3.2205 16.2661C3.36169 16.1249 3.55318 16.0456 3.75284 16.0456H18.8097C19.0093 16.0456 19.2008 16.1249 19.342 16.2661C19.4832 16.4073 19.5625 16.5988 19.5625 16.7984C19.5625 16.9981 19.4832 17.1896 19.342 17.3308C19.2008 17.4719 19.0093 17.5513 18.8097 17.5513H3.75284C3.55318 17.5513 3.36169 17.4719 3.2205 17.3308C3.07932 17.1896 3 16.9981 3 16.7984ZM3 10.7757C3 10.576 3.07932 10.3845 3.2205 10.2434C3.36169 10.1022 3.55318 10.0228 3.75284 10.0228H18.8097C19.0093 10.0228 19.2008 10.1022 19.342 10.2434C19.4832 10.3845 19.5625 10.576 19.5625 10.7757C19.5625 10.9754 19.4832 11.1668 19.342 11.308C19.2008 11.4492 19.0093 11.5285 18.8097 11.5285H3.75284C3.55318 11.5285 3.36169 11.4492 3.2205 11.308C3.07932 11.1668 3 10.9754 3 10.7757ZM3 4.75296C3 4.5533 3.07932 4.36181 3.2205 4.22062C3.36169 4.07944 3.55318 4.00012 3.75284 4.00012H18.8097C19.0093 4.00012 19.2008 4.07944 19.342 4.22062C19.4832 4.36181 19.5625 4.5533 19.5625 4.75296C19.5625 4.95263 19.4832 5.14412 19.342 5.2853C19.2008 5.42649 19.0093 5.5058 18.8097 5.5058H3.75284C3.55318 5.5058 3.36169 5.42649 3.2205 5.2853C3.07932 5.14412 3 4.95263 3 4.75296Z"
                  fill="#91E5F6"
                />
              </svg>
            </div>
            <div
              className="icon-login-header"
              onClick={this.handleLoginIconClick}
              ref={this.loginDropdownRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  d="M11 11C12.094 11 13.1432 10.5654 13.9168 9.79182C14.6904 9.01823 15.125 7.96902 15.125 6.875C15.125 5.78098 14.6904 4.73177 13.9168 3.95818C13.1432 3.1846 12.094 2.75 11 2.75C9.90598 2.75 8.85677 3.1846 8.08318 3.95818C7.3096 4.73177 6.875 5.78098 6.875 6.875C6.875 7.96902 7.3096 9.01823 8.08318 9.79182C8.85677 10.5654 9.90598 11 11 11ZM13.75 6.875C13.75 7.60435 13.4603 8.30382 12.9445 8.81954C12.4288 9.33527 11.7293 9.625 11 9.625C10.2707 9.625 9.57118 9.33527 9.05546 8.81954C8.53973 8.30382 8.25 7.60435 8.25 6.875C8.25 6.14565 8.53973 5.44618 9.05546 4.93046C9.57118 4.41473 10.2707 4.125 11 4.125C11.7293 4.125 12.4288 4.41473 12.9445 4.93046C13.4603 5.44618 13.75 6.14565 13.75 6.875ZM19.25 17.875C19.25 19.25 17.875 19.25 17.875 19.25H4.125C4.125 19.25 2.75 19.25 2.75 17.875C2.75 16.5 4.125 12.375 11 12.375C17.875 12.375 19.25 16.5 19.25 17.875ZM17.875 17.8695C17.8736 17.5312 17.6632 16.5138 16.731 15.5815C15.8345 14.685 14.1474 13.75 11 13.75C7.85125 13.75 6.1655 14.685 5.269 15.5815C4.33675 16.5138 4.12775 17.5312 4.125 17.8695H17.875Z"
                  fill="#B49662"
                />
              </svg>

              <div
                className={
                  isLoginDropdownVisible
                    ? "dropdown-login-header visible"
                    : "dropdown-login-header"
                }
                ref={this.loginDropdownRef}
              >
                <ul>
                  <li>
                    <div className="profile-container">
                      <div className="profile-image-1">
                        <img
                          src={ProfileLogin}
                          alt="Profile Image"
                          className="profile-image"
                        />
                      </div>
                      <div className="profile-text">
                        <p className="name">Sara Svensson</p>
                        <p className="login-time">Login Time: 09:30</p>
                      </div>
                    </div>

                    <a href="/bid-type/frontend/bid/auction">
                      <li class="login-option">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M7.59988 0C7.43268 0 7.26738 0.0057 7.10303 0.01615L7.16383 0.96425C7.45423 0.945482 7.74553 0.945482 8.03593 0.96425L8.09673 0.01615C7.93133 0.00542567 7.76563 3.95314e-05 7.59988 0ZM6.11788 0.1444C5.78918 0.20995 5.46808 0.2964 5.15648 0.4009L5.46143 1.3015C5.73408 1.2084 6.01433 1.13335 6.30123 1.07635L6.11788 0.14535V0.1444ZM10.0433 0.40185C9.72912 0.295339 9.40827 0.209653 9.08283 0.14535L8.89853 1.07635C9.18543 1.13335 9.46568 1.20935 9.73833 1.3015L10.0433 0.40185ZM11.8226 1.2806C11.5469 1.09606 11.2594 0.929768 10.9619 0.7828L10.5411 1.634C10.8023 1.7632 11.0541 1.9095 11.2944 2.07005L11.8226 1.2806ZM4.23688 0.7828C3.93858 0.93005 3.65168 1.0963 3.37713 1.2806L3.90533 2.0691C4.14678 1.90794 4.39843 1.7626 4.65868 1.634L4.23688 0.7828ZM2.58863 1.88575C2.33973 2.10425 2.10413 2.33985 1.88563 2.58875L2.60003 3.21575C2.79193 2.99725 2.99713 2.79205 3.21563 2.60015L2.58863 1.88575ZM13.3141 2.58875C13.0953 2.33943 12.8605 2.1046 12.6111 1.88575L11.9841 2.60015C12.2026 2.79205 12.4088 2.99725 12.5997 3.21575L13.3141 2.58875ZM14.4171 4.237C14.2701 3.93984 14.1038 3.65264 13.9193 3.37725L13.1308 3.90545C13.2913 4.1458 13.4367 4.39755 13.5659 4.6588L14.4171 4.237ZM1.28048 3.37725C1.09618 3.6518 0.928981 3.9387 0.782681 4.23795L1.63388 4.6588C1.76308 4.39755 1.90938 4.1458 2.06993 3.90545L1.28048 3.37725ZM0.401731 5.1566C0.295218 5.47077 0.209532 5.79161 0.145231 6.11705L1.07623 6.30135C1.13323 6.01445 1.20923 5.7342 1.30138 5.46155L0.401731 5.1566ZM15.0555 6.118C14.9912 5.79224 14.9055 5.47107 14.799 5.1566L13.8984 5.46155C13.9915 5.7342 14.0665 6.01445 14.1235 6.30135L15.0545 6.11705L15.0555 6.118ZM0.0160313 7.10315C-0.00534375 7.43404 -0.00534375 7.76596 0.0160313 8.09685L0.964131 8.03605C0.945363 7.74565 0.945363 7.45435 0.964131 7.16395L0.0160313 7.10315ZM15.1999 7.6C15.1999 7.43425 15.1945 7.26855 15.1837 7.10315L14.2356 7.16395C14.2544 7.45435 14.2544 7.74565 14.2356 8.03605L15.1837 8.09685C15.1945 7.93145 15.1999 7.76575 15.1999 7.6ZM0.144281 9.082C0.209831 9.4107 0.296281 9.7318 0.400781 10.0434L1.30138 9.73845C1.20795 9.46377 1.13273 9.18323 1.07623 8.89865L0.145231 9.08295L0.144281 9.082ZM14.798 10.0434C14.9044 9.7318 14.9899 9.4107 15.0545 9.08295L14.1235 8.89865C14.0665 9.18555 13.9905 9.4658 13.8984 9.73845L14.798 10.0434ZM0.782681 10.963C0.929686 11.2601 1.09597 11.5473 1.28048 11.8228L2.06898 11.2946C1.90766 11.0532 1.76231 10.8015 1.63388 10.5412L0.782681 10.9621V10.963ZM13.9193 11.8228C14.1036 11.5482 14.2708 11.2613 14.4171 10.9621L13.5659 10.5412C13.4367 10.8025 13.2904 11.0542 13.1298 11.2946L13.9193 11.8228ZM1.88563 12.6112C2.10413 12.8602 2.33973 13.0958 2.58863 13.3143L3.21563 12.5999C2.99729 12.4082 2.79166 12.2026 2.60003 11.9843L1.88563 12.6112ZM12.6111 13.3143C12.86 13.0958 13.0956 12.8602 13.3141 12.6112L12.5997 11.9843C12.4088 12.2028 12.2026 12.4089 11.9841 12.5999L12.6111 13.3143ZM10.9629 14.4172C11.2612 14.2699 11.5481 14.1037 11.8226 13.9194L11.2944 13.1309C11.053 13.2921 10.8013 13.4374 10.5411 13.566L10.9619 14.4172H10.9629ZM3.37713 13.9194C3.65168 14.1037 3.93858 14.2709 4.23783 14.4172L4.65868 13.566C4.39831 13.4373 4.14665 13.2916 3.90533 13.13L3.37713 13.9194ZM5.15648 14.7982C5.46808 14.9045 5.78918 14.9901 6.11693 15.0547L6.30123 14.1237C6.01666 14.0671 5.73612 13.9919 5.46143 13.8985L5.15648 14.7982ZM9.08188 15.0556C9.40764 14.9913 9.72881 14.9057 10.0433 14.7991L9.73833 13.8985C9.46365 13.9919 9.1831 14.0671 8.89853 14.1237L9.08283 15.0547L9.08188 15.0556ZM7.10303 15.1839C7.43392 15.2053 7.76584 15.2053 8.09673 15.1839L8.03593 14.2358C7.74553 14.2545 7.45423 14.2545 7.16383 14.2358L7.10303 15.1839ZM8.07488 4.275C8.07488 4.14902 8.02484 4.0282 7.93576 3.93912C7.84668 3.85004 7.72586 3.8 7.59988 3.8C7.4739 3.8 7.35309 3.85004 7.26401 3.93912C7.17493 4.0282 7.12488 4.14902 7.12488 4.275V7.125H4.27488C4.1489 7.125 4.02809 7.17505 3.93901 7.26412C3.84993 7.3532 3.79988 7.47402 3.79988 7.6C3.79988 7.72598 3.84993 7.8468 3.93901 7.93588C4.02809 8.02496 4.1489 8.075 4.27488 8.075H7.12488V10.925C7.12488 11.051 7.17493 11.1718 7.26401 11.2609C7.35309 11.35 7.4739 11.4 7.59988 11.4C7.72586 11.4 7.84668 11.35 7.93576 11.2609C8.02484 11.1718 8.07488 11.051 8.07488 10.925V8.075H10.9249C11.0509 8.075 11.1717 8.02496 11.2608 7.93588C11.3498 7.8468 11.3999 7.72598 11.3999 7.6C11.3999 7.47402 11.3498 7.3532 11.2608 7.26412C11.1717 7.17505 11.0509 7.125 10.9249 7.125H8.07488V4.275Z"
                            fill="#74B2F7"
                          />
                        </svg>
                        <span class="login-label">Orders</span>
                      </li>
                    </a>

                    <a href="/bid-type/frontend/messages">
                      <li class="login-option">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_126_2457)">
                            <path
                              d="M7.1806 13.9355C6.81792 13.9355 6.47685 13.7951 6.22037 13.5378L3.96242 11.2807H2.39383C1.7591 11.2802 1.15049 11.0279 0.701664 10.579C0.252836 10.1302 0.000476709 9.52162 0 8.88688L0 2.842C0.000953379 2.08824 0.300931 1.36564 0.834092 0.83282C1.36725 0.299996 2.09004 0.000476162 2.8438 0L12.2067 0C12.7774 0.000237556 13.3246 0.226835 13.7283 0.630068C14.1321 1.0333 14.3593 1.58023 14.3603 2.15085V8.88688C14.3601 9.52153 14.1079 10.1301 13.6592 10.579C13.2105 11.0278 12.602 11.2802 11.9674 11.2807H10.4006L8.14173 13.5378C8.01579 13.6643 7.866 13.7647 7.70102 13.8329C7.53604 13.9012 7.35915 13.9361 7.1806 13.9355ZM2.8438 0.683052C2.27143 0.683528 1.72261 0.910989 1.31772 1.31555C0.912823 1.7201 0.684905 2.26873 0.683952 2.8411V8.88598C0.683952 9.83091 1.4516 10.5959 2.39383 10.5959H4.245L6.70273 13.0536C6.83163 13.1758 7.00251 13.2439 7.18015 13.2439C7.35779 13.2439 7.52866 13.1758 7.65756 13.0536L10.1144 10.5959H11.9665C12.4196 10.5954 12.8541 10.415 13.1744 10.0944C13.4946 9.7738 13.6745 9.33916 13.6745 8.88598V2.14995C13.6745 1.34091 13.0167 0.683052 12.2067 0.683052H2.8438Z"
                              fill="#B49662"
                            />
                            <path
                              d="M10.5989 4.78394H3.4192C3.3289 4.78394 3.24228 4.74813 3.17834 4.68436C3.1144 4.62059 3.07836 4.53407 3.07813 4.44377C3.07801 4.39886 3.08674 4.35437 3.10381 4.31283C3.12089 4.27129 3.14598 4.23353 3.17765 4.20169C3.20932 4.16985 3.24696 4.14456 3.2884 4.12727C3.32985 4.10997 3.37429 4.10101 3.4192 4.10089H10.5998C10.6461 4.09857 10.6924 4.10571 10.7359 4.12185C10.7794 4.138 10.8192 4.16282 10.8527 4.19482C10.8863 4.22681 10.9131 4.2653 10.9313 4.30795C10.9495 4.35059 10.9589 4.39651 10.9589 4.44289C10.9588 4.48928 10.9493 4.53516 10.9309 4.57776C10.9126 4.62036 10.8858 4.65878 10.8521 4.69068C10.8184 4.72259 10.7786 4.74731 10.7351 4.76334C10.6916 4.77937 10.6452 4.78638 10.5989 4.78394ZM9.57477 7.17778H4.44513C4.39881 7.18015 4.35248 7.17308 4.30898 7.157C4.26547 7.14091 4.22569 7.11613 4.19206 7.08419C4.15843 7.05224 4.13165 7.01378 4.11335 6.97116C4.09505 6.92854 4.08562 6.88264 4.08562 6.83625C4.08562 6.78986 4.09505 6.74396 4.11335 6.70134C4.13165 6.65872 4.15843 6.62026 4.19206 6.58831C4.22569 6.55637 4.26547 6.53159 4.30898 6.5155C4.35248 6.49942 4.39881 6.49235 4.44513 6.49472H9.57297C9.66355 6.49449 9.75051 6.53024 9.81473 6.59412C9.87895 6.658 9.91516 6.74477 9.9154 6.83535C9.91564 6.92593 9.87988 7.01289 9.81601 7.07711C9.75213 7.14133 9.66535 7.17754 9.57477 7.17778Z"
                              fill="#B49662"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_126_2457">
                              <rect
                                width="14.399"
                                height="14.399"
                                fill="white"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <span class="login-label">Messages</span>
                      </li>
                    </a>

 

                    <a href="/bid-type/frontend/my-account-detail">
                      <li class="login-option">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M6.5 6.5C7.36195 6.5 8.1886 6.15759 8.7981 5.5481C9.40759 4.9386 9.75 4.11195 9.75 3.25C9.75 2.38805 9.40759 1.5614 8.7981 0.951903C8.1886 0.34241 7.36195 0 6.5 0C5.63805 0 4.8114 0.34241 4.2019 0.951903C3.59241 1.5614 3.25 2.38805 3.25 3.25C3.25 4.11195 3.59241 4.9386 4.2019 5.5481C4.8114 6.15759 5.63805 6.5 6.5 6.5ZM8.66667 3.25C8.66667 3.82464 8.43839 4.37574 8.03206 4.78206C7.62574 5.18839 7.07464 5.41667 6.5 5.41667C5.92536 5.41667 5.37426 5.18839 4.96794 4.78206C4.56161 4.37574 4.33333 3.82464 4.33333 3.25C4.33333 2.67536 4.56161 2.12426 4.96794 1.71794C5.37426 1.31161 5.92536 1.08333 6.5 1.08333C7.07464 1.08333 7.62574 1.31161 8.03206 1.71794C8.43839 2.12426 8.66667 2.67536 8.66667 3.25ZM13 11.9167C13 13 11.9167 13 11.9167 13H1.08333C1.08333 13 0 13 0 11.9167C0 10.8333 1.08333 7.58333 6.5 7.58333C11.9167 7.58333 13 10.8333 13 11.9167ZM11.9167 11.9123C11.9156 11.6458 11.7498 10.8442 11.0153 10.1097C10.309 9.40333 8.97975 8.66667 6.5 8.66667C4.01917 8.66667 2.691 9.40333 1.98467 10.1097C1.25017 10.8442 1.0855 11.6458 1.08333 11.9123H11.9167Z"
                            fill="#B49662"
                          />
                        </svg>
                        <span class="login-label">My Profile</span>
                      </li>
                    </a>

                    <a href="/bid-type/frontend/settings">
                      <li class="login-option">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M7.67863 4.56348C7.26942 4.56348 6.86421 4.64408 6.48614 4.80068C6.10807 4.95728 5.76455 5.18681 5.47519 5.47617C5.18583 5.76553 4.9563 6.10905 4.7997 6.48712C4.6431 6.86518 4.5625 7.27039 4.5625 7.67961C4.5625 8.08883 4.6431 8.49403 4.7997 8.8721C4.9563 9.25017 5.18583 9.59369 5.47519 9.88305C5.76455 10.1724 6.10807 10.4019 6.48614 10.5585C6.86421 10.7151 7.26942 10.7957 7.67863 10.7957C8.50508 10.7957 9.29768 10.4674 9.88207 9.88305C10.4665 9.29866 10.7948 8.50606 10.7948 7.67961C10.7948 6.85316 10.4665 6.06056 9.88207 5.47617C9.29768 4.89178 8.50508 4.56348 7.67863 4.56348ZM5.52249 7.67961C5.52249 7.10776 5.74966 6.55934 6.15401 6.15499C6.55837 5.75063 7.10679 5.52347 7.67863 5.52347C8.25048 5.52347 8.7989 5.75063 9.20325 6.15499C9.60761 6.55934 9.83477 7.10776 9.83477 7.67961C9.83477 8.25145 9.60761 8.79988 9.20325 9.20423C8.7989 9.60859 8.25048 9.83575 7.67863 9.83575C7.10679 9.83575 6.55837 9.60859 6.15401 9.20423C5.74966 8.79988 5.52249 8.25145 5.52249 7.67961Z"
                            fill="#B49662"
                          />
                          <path
                            d="M9.4036 1.28879C8.89768 -0.429596 6.46122 -0.429596 5.95531 1.28879L5.86507 1.59503C5.82974 1.71498 5.76801 1.82551 5.68441 1.9185C5.60082 2.0115 5.49747 2.08461 5.38194 2.13248C5.26642 2.18035 5.14165 2.20175 5.01678 2.19513C4.8919 2.18851 4.77009 2.15403 4.66028 2.09422L4.37996 1.94062C2.80558 1.08431 1.08431 2.80654 1.94158 4.37996L2.09422 4.66028C2.15403 4.77009 2.18851 4.8919 2.19513 5.01678C2.20175 5.14165 2.18035 5.26642 2.13248 5.38194C2.08461 5.49747 2.0115 5.60082 1.9185 5.68441C1.82551 5.76801 1.71498 5.82974 1.59503 5.86507L1.28879 5.95531C-0.429596 6.46122 -0.429596 8.89768 1.28879 9.4036L1.59503 9.49384C1.71498 9.52917 1.82551 9.59089 1.9185 9.67449C2.0115 9.75809 2.08461 9.86144 2.13248 9.97696C2.18035 10.0925 2.20175 10.2173 2.19513 10.3421C2.18851 10.467 2.15403 10.5888 2.09422 10.6986L1.94062 10.9789C1.08431 12.5533 2.80558 14.2756 4.37996 13.4173L4.66028 13.2647C4.77009 13.2049 4.8919 13.1704 5.01678 13.1638C5.14165 13.1572 5.26642 13.1786 5.38194 13.2264C5.49747 13.2743 5.60082 13.3474 5.68441 13.4404C5.76801 13.5334 5.82974 13.6439 5.86507 13.7639L5.95531 14.0701C6.46122 15.7885 8.89768 15.7885 9.4036 14.0701L9.49384 13.7639C9.52917 13.6439 9.59089 13.5334 9.67449 13.4404C9.75809 13.3474 9.86144 13.2743 9.97696 13.2264C10.0925 13.1786 10.2173 13.1572 10.3421 13.1638C10.467 13.1704 10.5888 13.2049 10.6986 13.2647L10.9789 13.4183C12.5533 14.2756 14.2756 12.5524 13.4173 10.9789L13.2647 10.6986C13.2049 10.5888 13.1704 10.467 13.1638 10.3421C13.1572 10.2173 13.1786 10.0925 13.2264 9.97696C13.2743 9.86144 13.3474 9.75809 13.4404 9.67449C13.5334 9.59089 13.6439 9.52917 13.7639 9.49384L14.0701 9.4036C15.7885 8.89768 15.7885 6.46122 14.0701 5.95531L13.7639 5.86507C13.6439 5.82974 13.5334 5.76801 13.4404 5.68441C13.3474 5.60082 13.2743 5.49747 13.2264 5.38194C13.1786 5.26642 13.1572 5.14165 13.1638 5.01678C13.1704 4.8919 13.2049 4.77009 13.2647 4.66028L13.4183 4.37996C14.2756 2.80558 12.5524 1.08431 10.9789 1.94158L10.6986 2.09422C10.5888 2.15403 10.467 2.18851 10.3421 2.19513C10.2173 2.20175 10.0925 2.18035 9.97696 2.13248C9.86144 2.08461 9.75809 2.0115 9.67449 1.9185C9.59089 1.82551 9.52917 1.71498 9.49384 1.59503L9.4036 1.28879ZM6.87594 1.56047C7.1121 0.758873 8.24681 0.758873 8.48297 1.56047L8.5732 1.8667C8.64906 2.12406 8.78156 2.36118 8.96097 2.56068C9.14038 2.76018 9.36217 2.91699 9.61007 3.01963C9.85797 3.12227 10.1257 3.16813 10.3936 3.15385C10.6615 3.13957 10.9229 3.06551 11.1585 2.93709L11.4378 2.7835C12.1713 2.3851 12.9738 3.18669 12.5744 3.92109L12.4218 4.2014C12.2936 4.43701 12.2197 4.69832 12.2056 4.96619C12.1915 5.23405 12.2374 5.50168 12.3402 5.74947C12.4429 5.99726 12.5997 6.21892 12.7993 6.39822C12.9988 6.57753 13.2359 6.70992 13.4932 6.7857L13.7984 6.87594C14.6 7.1121 14.6 8.24681 13.7984 8.48297L13.4922 8.5732C13.2348 8.64906 12.9977 8.78156 12.7982 8.96097C12.5987 9.14038 12.4419 9.36217 12.3393 9.61007C12.2366 9.85797 12.1908 10.1257 12.2051 10.3936C12.2193 10.6615 12.2934 10.9229 12.4218 11.1585L12.5754 11.4378C12.9738 12.1713 12.1722 12.9738 11.4378 12.5744L11.1585 12.4218C10.9228 12.2934 10.6614 12.2194 10.3934 12.2052C10.1255 12.1909 9.8577 12.2369 9.60979 12.3396C9.36187 12.4424 9.1401 12.5993 8.96073 12.7989C8.78137 12.9985 8.64895 13.2357 8.5732 13.4932L8.48297 13.7984C8.24681 14.6 7.1121 14.6 6.87594 13.7984L6.7857 13.4922C6.70981 13.235 6.57734 12.998 6.39799 12.7986C6.21864 12.5992 5.99696 12.4424 5.74919 12.3398C5.50141 12.2372 5.23382 12.1913 4.96601 12.2055C4.69819 12.2197 4.43695 12.2936 4.2014 12.4218L3.92109 12.5754C3.18765 12.9738 2.3851 12.1722 2.78446 11.4378L2.93709 11.1585C3.06569 10.9228 3.13989 10.6614 3.15427 10.3934C3.16865 10.1253 3.12283 9.85748 3.02018 9.60946C2.91752 9.36144 2.76064 9.13954 2.56104 8.96006C2.36145 8.78058 2.1242 8.64807 1.8667 8.57224L1.56047 8.48201C0.758873 8.24585 0.758873 7.11114 1.56047 6.87498L1.8667 6.78474C2.1238 6.70881 2.36066 6.57636 2.55995 6.39708C2.75925 6.2178 2.91594 5.99623 3.01855 5.74858C3.12117 5.50093 3.16711 5.23346 3.15301 4.96577C3.13892 4.69807 3.06515 4.43691 2.93709 4.2014L2.7835 3.92109C2.3851 3.18765 3.18669 2.3851 3.92109 2.78446L4.2014 2.93709C4.43695 3.06533 4.69819 3.13924 4.96601 3.15343C5.23382 3.16762 5.50141 3.12172 5.74919 3.01909C5.99696 2.91647 6.21864 2.75971 6.39799 2.56032C6.57734 2.36092 6.70981 2.12393 6.7857 1.8667L6.87594 1.56047Z"
                            fill="#B49662"
                          />
                        </svg>
                        <span class="login-label">Settings</span>
                      </li>
                    </a>
                  </li>
                  <br />
                  <br />
                  <br />
                  <li class="login-option2">
                    <div class="line"></div>
                    <a href="/bid-type/frontend/signin" class="signout2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_13_940)">
                            <path
                              d="M17.3077 20.2004H3.35766C3.0743 20.2002 2.80259 20.0876 2.60222 19.8872C2.40186 19.6868 2.28922 19.4151 2.28906 19.1318V5.18237C2.28906 4.59317 2.76846 4.11377 3.35766 4.11377H17.3071C17.8963 4.11377 18.3757 4.59257 18.3757 5.18237V8.55737C18.3757 8.63073 18.3465 8.70108 18.2946 8.75296C18.2428 8.80483 18.1724 8.83397 18.0991 8.83397C18.0257 8.83397 17.9553 8.80483 17.9035 8.75296C17.8516 8.70108 17.8225 8.63073 17.8225 8.55737V5.18237C17.8221 5.04593 17.7678 4.91518 17.6713 4.8187C17.5749 4.72223 17.4441 4.66789 17.3077 4.66757H3.35766C3.22123 4.66789 3.09047 4.72223 2.99399 4.8187C2.89752 4.91518 2.84318 5.04593 2.84286 5.18237V19.1324C2.84318 19.2688 2.89752 19.3996 2.99399 19.496C3.09047 19.5925 3.22123 19.6469 3.35766 19.6472H17.3071C17.4435 19.6469 17.5743 19.5925 17.6707 19.496C17.7672 19.3996 17.8215 19.2688 17.8219 19.1324V15.7916C17.8219 15.7182 17.851 15.6479 17.9029 15.596C17.9548 15.5441 18.0251 15.515 18.0985 15.515C18.1718 15.515 18.2422 15.5441 18.294 15.596C18.3459 15.6479 18.3751 15.7182 18.3751 15.7916V19.1324C18.3751 19.4155 18.2626 19.6871 18.0625 19.8873C17.8623 20.0876 17.5908 20.2002 17.3077 20.2004ZM19.9201 16.3694C19.8656 16.3698 19.8122 16.3541 19.7667 16.3242C19.7211 16.2944 19.6854 16.2517 19.6641 16.2016C19.6427 16.1515 19.6366 16.0962 19.6466 16.0427C19.6566 15.9892 19.6823 15.9398 19.7203 15.9008L23.3383 12.149L19.7353 8.41397C19.71 8.38777 19.6902 8.35686 19.677 8.32301C19.6637 8.28916 19.6572 8.25302 19.6579 8.21667C19.6586 8.18031 19.6665 8.14445 19.681 8.11113C19.6956 8.07781 19.7166 8.04768 19.7428 8.02247C19.7957 7.97155 19.8666 7.94373 19.9401 7.94514C19.9764 7.94583 20.0123 7.95368 20.0456 7.96824C20.0789 7.9828 20.109 8.00377 20.1343 8.02997L23.9221 11.957C23.972 12.0084 24 12.0772 24.0001 12.1488C24.0002 12.2205 23.9724 12.2894 23.9227 12.341L20.1193 16.2848C20.0935 16.3116 20.0625 16.3329 20.0283 16.3474C19.9941 16.3619 19.9573 16.3694 19.9201 16.3694Z"
                              fill="#B49662"
                            />
                            <path
                              d="M23.7221 12.4255H10.3313C10.2579 12.4255 10.1876 12.3964 10.1357 12.3445C10.0838 12.2926 10.0547 12.2223 10.0547 12.1489C10.0547 12.0756 10.0838 12.0052 10.1357 11.9533C10.1876 11.9015 10.2579 11.8723 10.3313 11.8723H23.7221C23.7954 11.8723 23.8658 11.9015 23.9177 11.9533C23.9695 12.0052 23.9987 12.0756 23.9987 12.1489C23.9987 12.2223 23.9695 12.2926 23.9177 12.3445C23.8658 12.3964 23.7954 12.4255 23.7221 12.4255Z"
                              fill="#B49662"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_13_940">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                transform="translate(0 0.157349)"
                              />
                            </clipPath>
                          </defs>
                        </svg>{" "}
                      </svg>
                      <span class="login-label2">Sign Out</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="flag-icon"
              onClick={this.handleFlagDropdownClick}
              ref={this.flagDropdownRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="18"
                viewBox="0 0 27 18"
                fill="none"
              >
                <path d="M0 0.5H27V17.5H0V0.5Z" fill="#012169" />
                <path
                  d="M3.16406 0.5L13.4578 6.91042L23.7094 0.5H27V2.69583L16.875 9.03542L27 15.3396V17.5H23.625L13.5 11.1604L3.41719 17.5H0V15.375L10.0828 9.07083L0 2.76667V0.5H3.16406Z"
                  fill="white"
                />
                <path
                  d="M17.8875 10.4521L27 16.0833V17.5L15.5672 10.4521H17.8875ZM10.125 11.1604L10.3781 12.4L2.27813 17.5H0L10.125 11.1604ZM27 0.5V0.60625L16.4953 7.26458L16.5797 5.70625L24.8906 0.5H27ZM0 0.5L10.0828 6.73333H7.55156L0 1.9875V0.5Z"
                  fill="#C8102E"
                />
                <path
                  d="M10.1672 0.5V17.5H16.9172V0.5H10.1672ZM0 6.16667V11.8333H27V6.16667H0Z"
                  fill="white"
                />
                <path
                  d="M0 7.33542V10.7354H27V7.33542H0ZM11.5172 0.5V17.5H15.5672V0.5H11.5172Z"
                  fill="#C8102E"
                />
              </svg>
              
              <div
                className={
                  isFlagDropdownVisible
                    ? "flag-dropdown visible"
                    : "flag-dropdown"
                }
                ref={this.flagDropdownRef}
              >
                <ul class="flag-dropdown visible">
                  <a href="en-us">
                    <li class="flag-option">
                      <svg
                        class="flag-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="20"
                        viewBox="0 0 27 20"
                        fill="none"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="18"
                          viewBox="0 0 27 18"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_245_879)">
                            <path
                              d="M0 0.655273H27V17.6553H0V0.655273Z"
                              fill="#012169"
                            />
                            <path
                              d="M3.16406 0.655273L13.4578 7.06569L23.7094 0.655273H27V2.85111L16.875 9.19069L27 15.4949V17.6553H23.625L13.5 11.3157L3.41719 17.6553H0V15.5303L10.0828 9.22611L0 2.92194V0.655273H3.16406Z"
                              fill="white"
                            />
                            <path
                              d="M17.8875 10.6074L27 16.2386V17.6553L15.5672 10.6074H17.8875ZM10.125 11.3157L10.3781 12.5553L2.27813 17.6553H0L10.125 11.3157ZM27 0.655273V0.761523L16.4953 7.41986L16.5797 5.86152L24.8906 0.655273H27ZM0 0.655273L10.0828 6.88861H7.55156L0 2.14277V0.655273Z"
                              fill="#C8102E"
                            />
                            <path
                              d="M10.1672 0.655273V17.6553H16.9172V0.655273H10.1672ZM0 6.32194V11.9886H27V6.32194H0Z"
                              fill="white"
                            />
                            <path
                              d="M0 7.49069V10.8907H27V7.49069H0ZM11.5172 0.655273V17.6553H15.5672V0.655273H11.5172Z"
                              fill="#C8102E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_245_879">
                              <rect
                                width="27"
                                height="17"
                                fill="white"
                                transform="translate(0 0.655273)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </svg>
                      <span class="flag-label">English</span>
                    </li>
                  </a>
                  <a href="sv-se">
                    <li class="flag-option">
                      <svg
                        class="flag-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="20"
                        viewBox="0 0 27 20"
                        fill="none"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="20"
                          viewBox="0 0 27 20"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_245_161)">
                            <path d="M0 0H27V20H0V0Z" fill="#066AA7" />
                            <path d="M0 8H27V12H0V8Z" fill="#FECC00" />
                            <path
                              d="M7.42505 0H11.475V20H7.42505V0Z"
                              fill="#FECC00"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_245_161">
                              <rect width="27" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>{" "}
                      </svg>
                      <span class="flag-label">Swedish</span>
                    </li>
                  </a>
                </ul>
              </div>
            </div>
            <YourComponent
              ref={this.yourComponentRef}
              isSearchBarVisible={isSearchBarVisible}
              handleInputChange={this.handleInputChange}
              handleKeyDown={this.handleKeyDown}
            />
          </div>
        </header>
      </div>
    );
  }
}

export default Header;
